const convertLocations = (locations, converterFunc) => {
  if (!Array.isArray(locations)) return [];
  const mapFunc = converterFunc || getNameIdSimplifiedLocation;
  return locations.map(mapFunc);
};

const convertMultiSelectOptions = ({
  selectedOptions,
  allLocations,
  converterFunc,
}) => {
  if (!Array.isArray(selectedOptions)) return [];
  if (isRawTrueValue(selectedOptions)) return allLocations.map(getNameIdSimplifiedLocation);
  return selectedOptions.map(converterFunc);
};

const getAPIFormat = (outOfStockLocations, allLocations) => {
  if (isRawTrueValue(outOfStockLocations) && Array.isArray(allLocations)) return convertLocations(allLocations, getNameIdSimplifiedLocation);
  if (!Array.isArray(outOfStockLocations) || outOfStockLocations.length === 0) return [];

  if (isInitialValueFromAPI(outOfStockLocations)) return outOfStockLocations;
  const convertMultiSelectArgs = { allLocations, selectedOptions: outOfStockLocations, converterFunc: getNameIdFromMultiSelectOption };
  if (isMultiSelectFriendlyValue(outOfStockLocations)) return convertMultiSelectOptions(convertMultiSelectArgs);
  if (isRegularLocationObject(outOfStockLocations)) return convertLocations(outOfStockLocations, getNameIdSimplifiedLocation);
};

/**
 * The PUT /products/:id/items route currently takes an array of location ids for outOfStockLocations,
 * instead of a name/id object like other routes.
 */
const getAPIFormatForUpdateAllItems = (outOfStockLocations, allLocations) => {
  if (isRawTrueValue(outOfStockLocations) && Array.isArray(allLocations)) return convertLocations(allLocations, simplifyLocationToId);
  if (!Array.isArray(outOfStockLocations) || outOfStockLocations.length === 0) return [];

  if (isInitialValueFromAPI(outOfStockLocations)) return convertLocations(outOfStockLocations, simplifyLocationToId);
  const convertMultiSelectArgs = { allLocations, selectedOptions: outOfStockLocations, converterFunc: getIdFromMultiSelectOption };
  if (isMultiSelectFriendlyValue(outOfStockLocations)) return convertMultiSelectOptions(convertMultiSelectArgs);
  if (isRegularLocationObject(outOfStockLocations)) return convertLocations(outOfStockLocations, simplifyLocationToId);
};

const getIdFromMultiSelectOption = elem => elem.value;
const getNameIdFromMultiSelectOption = elem => ({ name: elem.name, id: elem.value });

const getNameIdSimplifiedLocation = location => ({ name: location.name, id: location.id });
const simplifyLocationToId = location => location.id;

// If out-of-stock is still the initial value from the API with interface { name: <location_name>, id: <location_id> }, keep it
const isInitialValueFromAPI = outOfStockLocations => Object.keys(outOfStockLocations[0]).length === 2;

// MultiSelect-friendly values have a `value` key
const isMultiSelectFriendlyValue = outOfStockLocations => outOfStockLocations[0].hasOwnProperty('value');

// if the restaurant has just one location, out-of-stock can be a regular location object in state
const isRegularLocationObject = outOfStockLocations => outOfStockLocations[0].hasOwnProperty('address');

/**
 * For single location companies, out of stock starts as a boolean value before hydration.
 * This is for if a restaurant somehow clicks Apply Changes before hydration happens.
 */
const isRawTrueValue = outOfStockLocations => outOfStockLocations === true;

export {
  convertLocations,
  getAPIFormat,
  getAPIFormatForUpdateAllItems,
};
